<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row align-items-center mb-1">
        <div class="col-md-6">
          <div class="h2">Playlist Details</div>
        </div>
        <div class="col-md-2 offset-md-4 text-right center">
          <button type="submit" class="btn btn-warning btn-fill" @click="editPlaylist">Edit Playlist</button>
        </div>
      </div>
      <div class="table-responsive" v-if="playlist">
        <table class="table table-bordered table-light">
          <tr>
            <th>Id</th>
            <td>{{playlist.playlistId}}</td>
          </tr>
          <tr>
            <th>Corporation Name</th>
            <td>{{playlist.csvCorporationName}}</td>
          </tr>
          <tr>
            <th>Title</th>
            <td>{{playlist.playlistTitle}}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{{playlist.playlistDescription}}</td>
          </tr>
          <tr>
            <th>Videos</th>
            <td>{{playlist.csvVideoCodes}}</td>
          </tr>
          <tr>
            <th>Video Count</th>
            <td>{{playlist.videoCount}}</td>
          </tr>
          <tr>
            <th>Status</th>
            <td v-if="playlist.active == '0'">Inactive</td>
            <td v-else>Active</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import LTable from 'src/components/UIComponents/Table.vue'
  import { mapGetters } from 'vuex'
  export default {
    name: 'ViewPlaylist',
    components: {
      LTable,
    },
    created (){
      this.$store.dispatch('GETSELECTEDPLAYLIST', this.$route.params.id).then(() =>{
        console.log('selected', this.selectedPlaylist)
        this.playlist = this.selectedPlaylist;
      })
    },
    data () {
      return {
        playlist: {}
      }
    },
    methods: {
      editPlaylist(){
        this.$router.push({ name: 'Edit Playlist', params: { id: this.playlist.playlistId}})
      },
    },
    computed: {...mapGetters([
      'selectedPlaylist'])
    }
  }
</script>

<style>
  th{
    width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Playlists/PlaylistDetails.vue